<ng-container *ngIf="navstate$ | async as navstate">
  <button *ngIf="navstate.previous && !navstate.current.isBase" mat-icon-button (click)="navigateToPrev(navstate.previous)">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <h1 class="title" (click)="menuClick()">{{ navstate.current.title | translate }}</h1>
</ng-container>

